// src/App.tsx
import Header from './components/Header';
import Footer from './components/Footer';
import AppRoutes from './routes';
import ScrollToTop from './components/ScrollToTop';

function App() {
  return (
    <div className='min-h-screen flex flex-col'>
      <ScrollToTop />
      <Header />
      <main className='flex-grow'>
        <AppRoutes />
      </main>
      <Footer />
    </div>
  );
}

export default App;
